import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/space-thread.ts
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const spaceThreadIdSchema = z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(64).regex(/^thr_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u));
const spaceThreadSchema = z$1.strictObject({
	threadId: spaceThreadIdSchema,
	spaceId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	rootSignalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	createdByProfileId: openMeldRuntimeProfileIdSchema,
	createdAt: ISO_DATE_TIME_SCHEMA,
	updatedAt: ISO_DATE_TIME_SCHEMA
});
const spaceThreadContextSchema = z$1.strictObject({
	threadId: spaceThreadIdSchema,
	rootSignalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1))
});
const spaceThreadSignalPlacementKindSchema = z$1.enum(["root", "thread"]);
const spaceThreadSignalPlacementSchema = z$1.strictObject({
	threadId: spaceThreadIdSchema,
	signalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	placement: spaceThreadSignalPlacementKindSchema,
	createdAt: ISO_DATE_TIME_SCHEMA
});
const spaceThreadEventTypeSchema = z$1.enum(["created"]);
const spaceThreadEventSchema = z$1.strictObject({
	eventId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	threadId: spaceThreadIdSchema,
	eventType: spaceThreadEventTypeSchema,
	actorProfileId: openMeldRuntimeProfileIdSchema,
	clientMutationId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(200)),
	createdAt: ISO_DATE_TIME_SCHEMA
});
const spaceThreadActionRefSchema = z$1.strictObject({ threadId: spaceThreadIdSchema });
//#endregion
export { spaceThreadActionRefSchema, spaceThreadContextSchema, spaceThreadEventSchema, spaceThreadEventTypeSchema, spaceThreadIdSchema, spaceThreadSchema, spaceThreadSignalPlacementKindSchema, spaceThreadSignalPlacementSchema };

//# sourceMappingURL=space-thread.js.map